/* eslint-disable camelcase */

const itemsToOrders = (items) =>
  items.reduce((orders, item) => {
    let order = orders.find((ord) => ord.order_number === item.order_number);
    if (!order) {
      order = { order_number: item.order_number, items: [] };
      orders.push(order);
    }

    const {
      item_id,
      product_sku: sku,
      product_id,
      return_qty: quantity,
      parent_sku,
      product,
      return_reason_code_id,
      user_comment: user_comments,
    } = item;

    order.items.push({
      item_id,
      sku,
      product_id,
      quantity,
      parent_sku,
      product,
      return_reason_code_id,
      user_comments,
    });

    return orders;
  }, []);

export const getOrderWithMultiPayload = ({
  page: { locale, isSimpleReturns: simple_return },
  returnItems,
  confirmOrder: {
    order_number: primary_order_number,
    gift: gift_return,
    return_method,
    return_carrier,
    return_to_dc,
  },
}) => ({
  primary_order_number,
  simple_return: simple_return || false,
  gift_return: gift_return || false,
  locale,
  return_method,
  return_carrier,
  return_to_dc,
  orders: itemsToOrders(returnItems),
});
